import React from 'react';
import { AdvancedFilteringModal } from 'modals/advanced-filtering/AdvancedFilteringModal';
import { FilterContextProvider } from 'modals/advanced-filtering/context/FilterContext';
export const AdvancedFiltering = () => {
  return (
    <FilterContextProvider>
      <AdvancedFilteringModal />
    </FilterContextProvider>
  );
};
